import React from "react";
import { Grid, Stack } from "@mui/material";
import styled from "styled-components";

const Title = styled.p`
    margin: 0;
    padding: 7px 0 6px 18px;
    font-size: 12px;
`;

const SubTitle = styled.p`
    margin: 0;
    padding: 7px 0 6px 18px;
    font-size: 12px;
    opacity: 0.9;
    font-weight: 200;
`;

const ContentText = styled.p`
    margin: 0;
    padding: 7px 0 6px 0px;
    font-size: 12px;
`;

const GeneralConfigSection = ({ data, type }) => {
    if (!data) return <Title>No default {type} configuration found</Title>;
    return (
        <Grid container pt={1} pb={2}>
            <Grid item md={2.4}>
                <Stack direction="column">
                    <Title>Default Configuration</Title>
                    <Title>{data && data.defaultConfig ? "True" : "False"}</Title>
                </Stack>
            </Grid>
            <Grid item md={2.4}>
                <Stack direction="column">
                    <Title>Deployments</Title>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <SubTitle>Environment:</SubTitle>
                        <ContentText>
                            {(data && data.deployments && data.deployments.environment) || (
                                <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                            )}
                        </ContentText>
                    </Stack>
                </Stack>
            </Grid>
            <Grid item md={2.4}>
                <Stack direction="column">
                    <Title>Pipelines</Title>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <SubTitle>Workflow:</SubTitle>
                        <ContentText>
                            {(data && data.pipelines && data.pipelines.workflow) || (
                                <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                            )}
                        </ContentText>
                    </Stack>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <SubTitle>Branch:</SubTitle>
                        <ContentText>
                            {(data && data.pipelines && data.pipelines.branch) || (
                                <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                            )}
                        </ContentText>
                    </Stack>
                </Stack>
            </Grid>
            <Grid item md={2.4}>
                <Stack direction="column">
                    <Title>Releases</Title>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <SubTitle>Name:</SubTitle>
                        <ContentText>
                            {(data && data.releases && data.releases.name) || (
                                <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                            )}
                        </ContentText>
                    </Stack>
                </Stack>
            </Grid>
            <Grid item md={2.4}>
                <Stack direction="column">
                    <Title>Webhook</Title>
                    <Title>{data && data.webhook ? "True" : "False"}</Title>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default GeneralConfigSection;
